import {
  UserPlus,
  Edit3,
  Shield,
  Archive,
  ArchiveRestore,
  CheckCircle,
  CreditCard,
  Upload,
  FileText,
  MessageSquare,
  Search,
  Activity,
  Tag as TagIcon,
} from "lucide-react";
import { getThemeAccent, getThemeSuccess } from "@/theme/tokens";

// Getter-based so a runtime theme swap is respected. Kept lazy so tokens.js
// can read `document.documentElement` on the fly.
const accent = () => getThemeAccent();
const success = () => getThemeSuccess();
const silverBlue = "#A8B8D0";
const muted = "#5A7A9A";

const CONFIG = {
  "debtor.created":         { Icon: UserPlus,      color: success, label: (m) => `Added judgment ${m?.name || ""}` },
  "debtor.updated":         { Icon: Edit3,         color: () => silverBlue, label: (m) => `Updated ${m?.name || "judgment"}` },
  "debtor.tier_changed":    { Icon: Shield,        color: accent, label: (m) => `Changed ${m?.name || "judgment"}'s tier to ${(m?.tier || "").toUpperCase()}` },
  "debtor.archived":        { Icon: Archive,       color: () => muted, label: (m) => `Archived ${m?.name || "judgment"}` },
  "debtor.restored":        { Icon: ArchiveRestore, color: success, label: (m) => `Restored ${m?.name || "judgment"}` },
  "debtor.tags_updated":    { Icon: TagIcon,        color: accent, label: (m) => `Updated tags on ${m?.name || "judgment"}` },
  "tag.created":            { Icon: TagIcon,        color: accent, label: (m) => `Created tag "${m?.name || ""}"` },
  "tag.deleted":            { Icon: TagIcon,        color: () => muted, label: (m) => `Deleted tag "${m?.name || ""}"` },
  "onboarding.completed":   { Icon: CheckCircle,   color: success, label: () => "Completed onboarding" },
  "subscription.started":   { Icon: CreditCard,    color: accent, label: (m) => `Subscribed to ${(m?.plan_type || "").toUpperCase()} · ${m?.path || ""}` },
  "debtor.note_added":      { Icon: MessageSquare, color: () => silverBlue, label: (m) => `Added a note to ${m?.name || "judgment"}` },
  "debtor.document_uploaded": { Icon: Upload,      color: accent, label: (m) => `Uploaded ${m?.filename || "document"} to ${m?.name || "judgment"}` },
  "query.completed":        { Icon: Search,        color: success, label: (m) => `Query completed for ${m?.name || "judgment"}` },
  "report.generated":       { Icon: FileText,      color: accent, label: (m) => `Report generated for ${m?.name || "judgment"}` },
};

export const describeActivity = (event) => {
  const cfg = CONFIG[event.type];
  if (!cfg) {
    return { Icon: Activity, color: silverBlue, label: event.type };
  }
  return {
    Icon: cfg.Icon,
    color: typeof cfg.color === "function" ? cfg.color() : cfg.color,
    label: cfg.label(event.metadata || {}),
  };
};
